// Phrase generator: builds a random memorable phrase for room IDs
// Based on documentation from docs/01_HOMEPAGE_AND_NAVIGATION.md

const SUBJECTS = [
  'cat', 'dog', 'mountain', 'ocean', 'tree', 'river', 'sun', 'moon', 'star', 'cloud',
  'bird', 'fish', 'elephant', 'lion', 'tiger', 'bear', 'wolf', 'eagle', 'dolphin', 'whale',
  'flower', 'forest', 'lake', 'valley', 'hill', 'beach', 'island', 'desert', 'rain', 'snow',
  'house', 'car', 'book', 'phone', 'computer', 'table', 'chair', 'lamp', 'clock', 'door',
  'person', 'friend', 'family', 'teacher', 'doctor', 'artist', 'musician', 'dancer', 'writer', 'chef',
  'storm', 'wind', 'thunder', 'lightning', 'rainbow', 'sunset', 'sunrise', 'night', 'day', 'season',
  'garden', 'park', 'city', 'village', 'town', 'road', 'path', 'bridge', 'castle', 'tower',
  'horse', 'rabbit', 'deer', 'fox', 'butterfly', 'bee', 'ant', 'spider', 'snake', 'turtle',
  'piano', 'guitar', 'drum', 'violin', 'flute', 'trumpet', 'ball', 'kite', 'boat', 'plane',
  'apple', 'orange', 'banana', 'grape', 'cherry', 'strawberry', 'lemon', 'watermelon', 'peach', 'pear'
];

const VERBS = [
  'running', 'jumping', 'flying', 'swimming', 'walking', 'dancing', 'singing', 'playing',
  'sleeping', 'eating', 'drinking', 'reading', 'writing', 'drawing', 'painting', 'cooking',
  'climbing', 'diving', 'skating', 'surfing', 'sailing', 'riding', 'driving', 'flying',
  'thinking', 'dreaming', 'hoping', 'wishing', 'loving', 'laughing', 'smiling', 'crying',
  'shining', 'glowing', 'sparkling', 'blooming', 'growing', 'flowing', 'moving', 'standing',
  'sitting', 'lying', 'resting', 'waiting', 'watching', 'listening', 'talking', 'speaking',
  'building', 'creating', 'making', 'breaking', 'fixing', 'helping', 'learning', 'teaching',
  'working', 'studying', 'practicing', 'exercising', 'training', 'competing', 'winning', 'losing',
  'starting', 'stopping', 'beginning', 'ending', 'opening', 'closing', 'entering', 'leaving',
  'rising', 'falling', 'floating', 'sinking', 'spinning', 'turning', 'rolling', 'sliding'
];

const ADJECTIVES = [
  'red', 'blue', 'green', 'yellow', 'orange', 'purple', 'pink', 'black', 'white', 'gray',
  'big', 'small', 'large', 'tiny', 'huge', 'gigantic', 'mini', 'massive', 'enormous', 'little',
  'fast', 'slow', 'quick', 'rapid', 'swift', 'speedy', 'sluggish', 'lazy', 'active', 'energetic',
  'happy', 'sad', 'joyful', 'cheerful', 'glad', 'merry', 'jolly', 'bright', 'sunny', 'cloudy',
  'hot', 'cold', 'warm', 'cool', 'freezing', 'boiling', 'chilly', 'cozy', 'comfortable', 'pleasant',
  'beautiful', 'pretty', 'lovely', 'gorgeous', 'stunning', 'attractive', 'charming', 'elegant', 'graceful', 'magnificent',
  'strong', 'weak', 'powerful', 'mighty', 'tough', 'gentle', 'soft', 'hard', 'solid', 'firm',
  'new', 'old', 'young', 'ancient', 'modern', 'fresh', 'stale', 'vintage', 'classic', 'contemporary',
  'bright', 'dark', 'light', 'dim', 'shiny', 'dull', 'glossy', 'matte', 'transparent', 'opaque',
  'smooth', 'rough', 'soft', 'hard', 'silky', 'fuzzy', 'bumpy', 'slippery', 'sticky', 'crispy'
];

const COMPLEMENTS = [
  'quickly', 'slowly', 'rapidly', 'gently', 'softly', 'loudly', 'quietly', 'peacefully', 'calmly', 'wildly',
  'happily', 'sadly', 'joyfully', 'cheerfully', 'merrily', 'angrily', 'nervously', 'excitedly', 'eagerly', 'lazily',
  'carefully', 'carelessly', 'skillfully', 'clumsily', 'gracefully', 'awkwardly', 'smoothly', 'roughly', 'delicately', 'forcefully',
  'brightly', 'dimly', 'clearly', 'vaguely', 'sharply', 'blurrily', 'vividly', 'faintly', 'brilliantly', 'dully',
  'warmly', 'coldly', 'hotly', 'coolly', 'comfortably', 'uncomfortably', 'pleasantly', 'unpleasantly', 'nicely', 'badly',
  'perfectly', 'imperfectly', 'correctly', 'incorrectly', 'precisely', 'roughly', 'exactly', 'approximately', 'nearly', 'barely',
  'completely', 'partially', 'fully', 'halfway', 'entirely', 'somewhat', 'totally', 'slightly', 'mostly', 'hardly',
  'easily', 'difficultly', 'simply', 'complexly', 'effortlessly', 'strenuously', 'naturally', 'artificially', 'spontaneously', 'deliberately',
  'wisely', 'foolishly', 'intelligently', 'stupidly', 'cleverly', 'dumbly', 'smartly', 'dumbfoundingly', 'brilliantly', 'idiotically',
  'bravely', 'cowardly', 'boldly', 'timidly', 'courageously', 'fearfully', 'confidently', 'hesitantly', 'proudly', 'shamefully'
];

// Sentence structures as per documentation
const sentenceStructures = [
  '{ADJECTIVE} {SUBJECT} {VERB} {COMPLEMENT}',
  '{SUBJECT} {VERB} {ADJECTIVE} {COMPLEMENT}',
  '{ADJECTIVE} {SUBJECT} {COMPLEMENT}',
  '{SUBJECT} {VERB} {COMPLEMENT}',
  '{ADJECTIVE} {VERB} {SUBJECT}',
  '{VERB} {ADJECTIVE} {SUBJECT}',
  '{SUBJECT} {ADJECTIVE} {VERB}',
  '{COMPLEMENT} {SUBJECT} {VERB}',
  '{VERB} {SUBJECT} {ADJECTIVE}',
  '{ADJECTIVE} {COMPLEMENT} {SUBJECT}'
];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Generate a random memorable phrase for room IDs
 * @returns {string} Generated phrase (e.g., "red-cat-jumping-quickly")
 */
export function generatePhrase() {
  const structure = pick(sentenceStructures);
  const subject = pick(SUBJECTS);
  const verb = pick(VERBS);
  const adjective = pick(ADJECTIVES);
  const complement = pick(COMPLEMENTS);
  
  return structure
    .replace('{SUBJECT}', subject)
    .replace('{VERB}', verb)
    .replace('{ADJECTIVE}', adjective)
    .replace('{COMPLEMENT}', complement);
}

/**
 * Convert phrase to URL-friendly slug
 * @param {string} phrase Input phrase
 * @returns {string} URL-friendly slug
 */
export function slugify(phrase) {
  if (!phrase) return '';
  return String(phrase)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

/**
 * Extract room ID from URL or phrase
 * @param {string} input URL or phrase
 * @returns {string} Clean room ID
 */
export function cleanRoomId(input) {
  if (!input) return '';
  
  const trimmed = input.trim().replace(/\/+$/, '');
  
  // If it's a full URL, extract the last part
  if (trimmed.includes('/')) {
    return trimmed.split('/').pop();
  }
  
  // Otherwise, just slugify it
  return slugify(trimmed);
}

/**
 * Get example placeholders for input field
 * @returns {string[]} Array of example phrases
 */
export function getExamplePhrases() {
  return [
    'fast-blue-elephant',
    'happy-red-mountain',
    'brave-green-ocean',
    'quiet-yellow-bird',
    'dancing-purple-flower',
    'jumping-orange-cat',
    'sleeping-pink-cloud',
    'running-black-wolf',
    'flying-white-eagle',
    'swimming-gray-dolphin'
  ];
}
